<template>
  <div class="main-container">

      <div class="main-menu-bar">
          <div v-if="isFTBStyleApplied && isLoggedIn" class="right-shadow"></div>

          <router-link class="main-menu-bar__logo" :to="getMainPage()" :title="$t('generic.application_name')" :alt="$t('generic.application_name')"></router-link>

          <nav v-if="getCurrentSession.state === 'ready' && getCurrentSession.data.user">
              <ul class="main-menu-bar__menu">
                  <li v-if="showSidemenu" class="main-menu-bar__menu__list-item main-menu-bar__menu__list-item--toggle-menu">
                    <a v-bind:class="['main-menu-bar__menu__list-item__link', { 'active': isSubmenuActive }]"
                       href="#!"
                       v-on:click="toggleSubMenu()"
                       :title="$t('generic.mainmenu.submenu')"
                       :alt="$t('generic.mainmenu.submenu')">
                          <span></span>
                          {{ $t('generic.mainmenu.submenu') }}
                      </a>
                  </li>

                  <li class="main-menu-bar__menu__list-item" v-for="(mainMenuItem) in Object.values(mainMenu)" :key="mainMenuItem.name">
                      <router-link v-if="mainMenuItem.visible" class="main-menu-bar__menu__list-item__link" v-bind:to="{name: mainMenuItem.name }">
                         <i class="main-menu-bar__menu__list-item__link__icon" v-bind:class="mainMenuItem.meta.icon"></i> {{ mainMenuItem.meta.title }}
                      </router-link>
                  </li>

                  <li class="main-menu-bar__menu__list-item hide-desktop">
                     <dq-usermenu v-if="getCurrentSession.state === 'ready' && getCurrentSession.data.user" :label="getCurrentSession.data.user.name" :showLogout="true"></dq-usermenu>
                  </li>
              </ul>
          </nav>
      </div>

    <div v-bind:class="['sub-menu-bar', { 'open': isOpenActive }, {'sub-menu-bar__ftb-menu-padding' : isFTBStyleApplied}]"
         v-if="getCurrentSession.state === 'ready' &&
         getCurrentSession.data.user && showSidemenu">
          <div class="right-shadow-sub-menu"></div>
          <nav v-if="$route.meta.sidemenu">
              <ul v-bind:class="['sub-menu-bar__menu',  { 'ftb-sub-menu-margin': isFTBStyleApplied}]"
                  v-if="$route.meta.sidemenu">
                  <img v-if="isFTBStyleApplied"
                       :src="ftbLogo"
                       class="right-shadow-sub-menu__ftb-logo"
                       alt="ftb-logo">
                  <h4>{{ $t('generic.submenu.title') }} <a class="reset__Link" @click="resetSubMenu">{{ $t('generic.submenu.reset_text') }}</a></h4>
                  <el-menu default-active="2" :unique-opened="true" @open="handleMenu" @close="handleMenu">
                      <dq-sidemenu :model="getOrganizationSimpleTree"/>
                  </el-menu>
              </ul>
          </nav>
      </div>

      <div class="loggedin-userinfo">
        <div v-if="isLoggedIn">
            <router-link :to="{name: 'logout'}" :title="$t('generic.logout.buttons.logout')" :alt="$t('generic.logout.buttons.logout')">{{ $t('generic.logout.buttons.logout') }}
              <i class="ion-ios-locked-outline"></i>
            </router-link>
        </div>
        <dq-usermenu v-if="isLoggedIn" :label="getCurrentSession.data.user.name"></dq-usermenu>

        <el-dropdown :class="[ isLoggedIn ? '' : 'el-lang']" trigger="click" @command="changeLanguage" menu-align="start">
            <span class="el-dropdown-link">
                <span class="flag-icon" :class="getFlagClass(currentLanguage)"></span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-languages">
                <el-dropdown-item command="en">
                  <span class="flag-icon"
                        :class="[isFTBStyleApplied ? 'flag-icon-us' : 'flag-icon-en']">
                  </span>
                </el-dropdown-item>
                <el-dropdown-item command="nl"><span class="flag-icon flag-icon-nl"></span></el-dropdown-item>
                <el-dropdown-item command="fr"><span class="flag-icon flag-icon-fr"></span></el-dropdown-item>
                <el-dropdown-item command="de"><span class="flag-icon flag-icon-de"></span></el-dropdown-item>
                <el-dropdown-item command="sk"><span class="flag-icon flag-icon-sk"></span></el-dropdown-item>
                <el-dropdown-item command="pl"><span class="flag-icon flag-icon-pl"></span></el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        
        <div class="el-dropdown">
          <el-button v-on:click="dialogTryNewPortal = true" size="small">{{ $t('generic.new_portal.title') }}</el-button>
        </div>
      </div>

      <div v-bind:class="['main-content', { 'open': isOpenActive }]">
        <router-view></router-view>

        <div class="copy-right">
          <div> &copy; {{ currentYear }} {{ buildProp.name }} v{{ buildProp.version }} - {{ $t('generic.copy_right') }} </div>
        </div>
      </div>

      <el-dialog v-model="dialogTryNewPortal" :title="$t('generic.new_portal.title')" size="tiny">
        <span v-html="$t('generic.new_portal.dialog.description_1')"></span>
        <!-- temporary hide: note with date when will v1 be deprecated -->
        <!-- <span v-html="$t('generic.new_portal.dialog.description_2')"></span> -->
        <span slot="footer" class="dialog-footer">
          <el-button v-on:click="dialogTryNewPortal = false">{{ $t('generic.overview.buttons.cancel') }}</el-button>
          <el-button type="primary" v-on:click="navigateToNewPortal">{{ $t('generic.new_portal.dialog.confirm') }}</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<style lang="scss">
  @import './assets/sass/app.scss';
</style>

<script>
  import Vue from 'vue'
  import ftbLogo from '../img/ftb-logo.png'

  const MainMenuKeys = Object.freeze({
    'management_unit': 0,
    'management_user': 1,
    'management_location': 2,
    'management_department': 3,
    'management_organization': 4,
    'management_till': 5,
    'management_mix': 6,
    'management_unitRoles': 7,
    'management_report': 8,
    'management_cit': 9,
    'management_softwaresettings': 10,
    'management_adminsettings': 11
  })

  export default {
    data () {
      return {
        selectedLanguage: Vue.config.lang,
        currentLanguage: '',
        mainMenu: {
          [MainMenuKeys.management_unit]: {
            name: 'management.unit',
            path: '/unit',
            visible: true,
            meta: {
              title: Vue.t('generic.mainmenu.units'),
              icon: 'ion-ios-list-outline'
            }
          },
          [MainMenuKeys.management_user]: {
            name: 'management.user',
            path: '/user',
            visible: true,
            meta: {
              title: Vue.t('generic.mainmenu.users'),
              icon: 'ion-ios-people-outline'
            }
          },
          [MainMenuKeys.management_location]: {
            name: 'management.location',
            path: '/location',
            visible: true,
            meta: {
              title: Vue.t('generic.mainmenu.locations'),
              icon: 'ion-ios-location-outline'
            }
          },
          [MainMenuKeys.management_department]: {
            name: 'management.department',
            path: '/department',
            visible: false,
            meta: {
              title: Vue.t('generic.mainmenu.departments'),
              icon: 'ion-network'
            }
          },
          [MainMenuKeys.management_organization]: {
            name: 'management.organization',
            path: '/organization',
            visible: true,
            meta: {
              title: Vue.t('generic.mainmenu.organizations'),
              icon: 'ion-ios-briefcase-outline'
            }
          },
          [MainMenuKeys.management_till]: {
            name: 'management.till',
            path: '/till',
            visible: false,
            meta: {
              title: Vue.t('generic.mainmenu.tills'),
              icon: 'ion-ios-folder-outline'
            }
          },
          [MainMenuKeys.management_mix]: {
            name: 'management.mix',
            path: '/mix',
            visible: false,
            meta: {
              title: Vue.t('generic.mainmenu.mixes'),
              icon: 'ion-calculator'
            }
          },
          // [MainMenuKeys.management_unitRoles]: {
          //   name: 'management.unitRoles',
          //   path: '/unit-roles',
          //   visible: false,
          //   meta: {
          //     title: Vue.t('generic.mainmenu.roles'),
          //     icon: 'ion-ios-personadd-outline'
          //   }
          // },
          [MainMenuKeys.management_report]: {
            name: 'management.report',
            path: '/report',
            visible: true,
            meta: {
              title: Vue.t('generic.mainmenu.report'),
              icon: 'ion-ios-paper-outline'
            }
          },
          [MainMenuKeys.management_cit]: {
            name: 'management.cit',
            path: '/cit',
            visible: false,
            meta: {
              title: Vue.t('generic.mainmenu.citworkflow'),
              icon: 'ion-cash'
            }
          },
          [MainMenuKeys.management_softwaresettings]: {
            name: 'management.softwaresettings',
            path: '/softwaresettings',
            visible: false,
            meta: {
              title: Vue.t('generic.mainmenu.softwaresettings'),
              icon: 'ion-ios-gear-outline'
            }
          },
          [MainMenuKeys.management_adminsettings]: {
            name: 'management.adminsettings',
            path: '/adminsettings',
            visible: false,
            meta: {
              title: Vue.t('generic.mainmenu.adminsettings'),
              icon: 'ion-android-desktop'
            }
          }
        },
        isSubmenuActive: false,
        showSidemenu: false,
        isOpenActive: false,
        buildProp: {},
        permissions: [{
          prefix: {
            organization: 'ORG_',
            till: 'TIL_',
            department: 'DEP_',
            unit: 'UNI_',
            user: 'USR_',
            location: 'LOC_',
            cit: 'SET_',
            report: 'REP_',
            softwaresettings: 'SET_',
            mix: 'MIX_',
            adminsettings: 'ADM_'
          },
          actions: {
            create: 'C',
            read: 'R',
            update: 'U',
            delete: 'D'
          }
        }],
        isFTBStyleApplied: false,
        ftbLogo,
        dialogTryNewPortal: false
      }
    },
    created () {
      this.getBuildProperties()
      this.currentLanguage = window.localStorage.getItem('lang')
      this.isFTBStyleApplied = process.env.FIFTH_THIRD_ENVIRONMENT === 'true'
    },
    mounted () {
      // Detect visibility change (tab hidden / visible)
      document.addEventListener('visibilitychange', this.handleVisibility)
      // Detect when user refocuses the tab window
      window.addEventListener('focus', this.handleVisibility)
    },
    beforeDestroy () {
      document.removeEventListener('visibilitychange', this.handleVisibility)
      window.removeEventListener('focus', this.handleVisibility)
    },
    watch: {
      '$route' (toRoute, fromRoute) {
        window.document.title = this.$route.meta.title + ' - ' + Vue.t('generic.application_name')
//         this.checkPermissions(toRoute)
        this.checkRoles()
      }
    },
    methods: {
      getJwtToken () {
        let idToken = window.localStorage.getItem('id_token')
        if (!idToken) {
          const vegaData = window.localStorage.getItem('vega')
          if (vegaData) {
            const { jwt_token: jwtToken } = JSON.parse(vegaData)
            idToken = jwtToken
          }
        }
        return idToken
      },
      handleVisibility () {
        if (!document.hidden) {
          // exclude redirecting if on non auth routes
          if (this.$route.name.includes('forgotPassword') || this.$route.name.includes('resetPassword')) {
            return
          }
          const token = this.getJwtToken()
          if (!token && !this.$route.name.includes('login')) {
            this.$store.getters['generalSession/getCurrentSession'].state = 'error'
            this.$router.replace({ name: 'logout' })
          }
          // if user is log in in a different tab or on v2, and come back to a tab where login page is active
          if (token && (this.$route.name.includes('login') || this.$route.name.includes('mfa'))) {
            this.$store.getters['generalSession/getCurrentSession'].state = 'undefined'
            this.$router.replace({ name: 'management.unit' })
          }
          if (token && this.$route.name.includes('logout')) {
            this.$router.replace({ name: 'management.unit' })
          }
          if (!token && this.$route.name.includes('logout')) {
            this.$router.replace({ name: 'login' })
          }
        }
      },
      getMainPage () {
        const session = this.$store.getters['generalSession/getCurrentSession']

        if (session && session.data && session.data.user) {
          return {name: 'management.unit'}
        }

        return {name: 'start'}
      },
      checkRoles () {
        var roles = this.getRoles

        if (Object.keys(roles).length === 0 && roles.constructor === Object && this.getCurrentSession.state === 'ready') {
          this.$dataApi().endpoints.user.getUserPermissions().then((response) => {
            if (response.status === 200) {
              var permissions = response.body
              this.$store.commit('generalSession/setRoles', permissions)

              for (const prop in permissions) {
                if (!permissions.hasOwnProperty(prop)) continue
                // Side-menu (organizations only) is permitted
                if (permissions[prop].permission === 'ORG_R') {
                  this.showSidemenu = true
                }
                if (permissions[prop].permission === 'DEP_R') {
                  this.mainMenu[MainMenuKeys.management_department].visible = true
                }
                if (permissions[prop].permission === 'TIL_R') {
                  this.mainMenu[MainMenuKeys.management_till].visible = true
                }
                if (permissions[prop].permission === 'MIX_R') {
                  this.mainMenu[MainMenuKeys.management_mix].visible = true
                }
                if (permissions[prop].permission === 'SET_R') {
                  this.mainMenu[MainMenuKeys.management_cit].visible = true
                  this.mainMenu[MainMenuKeys.management_softwaresettings].visible = true
                }
                if (permissions[prop].permission === 'ADM_R') {
                  this.mainMenu[MainMenuKeys.management_adminsettings].visible = true
                }
              }
            }
          })
        }
      },
      checkPermissions (route) {
        // Get the prefix
        var check = false
        var prefix = this.permissions[0].prefix[this.$route.path.split('/')[1]]
        var goTo = route.path.split('/')[2]
        var actions = this.permissions[0].actions

        var userSession = this.getCurrentSession

        var result = []
        if (userSession.data.user !== undefined) {
          result = userSession.data.user.userRoles
        }

        var arr = []
        for (var i = 0; i < result.length; i++) {
          arr.push(result[i]['code'])
          if (result[i]['code'] === 'superadmin' || result[i]['code'] === 'supervisor' || result[i]['code'] === 'dealer' || result[i]['code'] === 'dealerview') {
            this.mainMenu[MainMenuKeys.management_report].visible = true
            this.mainMenu[MainMenuKeys.management_cit].visible = true
            this.mainMenu[MainMenuKeys.management_department].visible = true
            break
          }
        }

        var permissions = userSession.roles
        if (goTo === 'create' || goTo === 'read' || goTo === 'update' || goTo === 'delete') {
          for (var property in permissions) {
            if (!permissions.hasOwnProperty(property)) continue

            // Action is permitted
            if (permissions[property].permission === prefix + actions[goTo]) {
              check = true
            }
          }

          if (!check) {
            this.$router.push({
              name: 'generic.error.ErrorPage',
              params: {
                error_response: {
                  error_message: 'unauthorized'
                }
              }
            })
          }
        }
      },
      toggleSubMenu () {
        this.isSubmenuActive = !this.isSubmenuActive
        this.isOpenActive = !this.isOpenActive
      },
      handleMenu (key) {
        if (this.$route.name !== 'management.unit.read') {
          this.$router.push({
            params: {
              uuid: key
            },
            name: this.$route.name
          })
        }
      },
      resetSubMenu () {
        if (this.$route.name !== 'management.unit.read') {
          this.$router.push({
            name: this.$route.name
          })
        }
      },
      changeLanguage (lang) {
        this.selectedLanguage = Vue.config.lang = lang
        window.localStorage.setItem('lang', lang)
        this.currentLanguage = window.localStorage.getItem('lang')
        if (!this.$route.fullPath.includes('mfa')) {
          window.location.reload()
        }
      },
      getFlagClass (id) {
        // ToDo: improve if US specific i18n is introduced
        if (this.isFTBStyleApplied && id === 'en') {
          id = 'us'
        }
        var value = ['flag-icon-' + id]
        if (this.orderKey === id) {
          value.push('active')
        }
        return value.join(' ')
      },
      getBuildProperties () {
        this.$dataApi().endpoints.utility.getBuildProperties().then((response) => {
          if (response.status === 200) {
            this.buildProp = response.body
          }
        })
      },
      navigateToNewPortal () {
        this.dialogTryNewPortal = false
        window.location.href = typeof process.env.V2_URL === 'function' ? process.env.V2_URL() : process.env.V2_URL
      }
    },
    computed: {
      getCurrentSession () {
        return this.$store.getters['generalSession/getCurrentSession']
      },
      getRoles () {
        return this.getCurrentSession.roles
      },
      getOrganizationSimpleTree () {
        return this.$store.getters['generalOrganization/getOrganizationSimpleTree']
      },
      isLoggedIn () {
        return this.getCurrentSession.state === 'ready' && this.getCurrentSession.data.user
      },
      currentYear () {
        return new Date().getFullYear()
      }
    },
    events: {
      // Increment the totalTime value based on the new
      // time entry that is dispatched up
      timeUpdate (timeEntry) {
        this.totalTime += parseFloat(timeEntry.totalTime)
      },
      // Decrement totalTime when a time entry is deleted
      deleteTime (timeEntry) {
        this.totalTime -= parseFloat(timeEntry.totalTime)
      }
    },
    filters: {
      uppercase: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.toUpperCase()
      }
    }
  }

</script>



// WEBPACK FOOTER //
// App.vue?fefdec4a